(function () {
  'use strict';

  var STYLE_ID = 'filter-prompt-styles';
  var RCC_CONTAINER_SELECTOR = '.rcc-search';
  var GRID_READY_EVENT = 'retail-connect:search-grid:ready';
  var PRODUCTS_LOAD_SUCCESS_EVENT = 'retail-connect:products:load:success';
  var GRID_PRODUCT_SELECTOR = '.rcc-search__product';
  var GRID_NORESULTS_SELECTOR = '.rcc-search__noresults';
  // Desktop sticky sidebar filters (left column layout)
  var DESKTOP_CONTROLS_SELECTOR =
    '.rcc-search__controls.rcc-search__controls--active.rcc-search__controls--sticky';
  // Mobile: filters live in the toolbar refine button; drawer controls are display:none when closed
  var MOBILE_MOUNT_SELECTOR = '.rcc-search__toolbar';
  var REFINE_SELECTOR = '.rcc-search__refine';
  var FILTER_TOKEN = '[[filter]]';
  var observedContainers = new WeakSet();
  var gridReadyListenerBound = false;
  var productsLoadListenerBound = false;
  var containerObserver = null;
  var containerPoll = null;
  var containerPollTimeout = null;
  var lastTotalResultCount = null;
  var stylesLoaded = false;
  var stylesLoading = null;
  var injectPending = false;

  var convertClassObserver = null;

  function getSettings() {
    return window.filterPromptSettings || {};
  }

  function getConvertClass(settings) {
    return String((settings && settings.convertClass) || '').trim();
  }

  function isConvertVariantActive(settings) {
    var cls = getConvertClass(settings);
    if (!cls) return false;
    if (document.documentElement.classList.contains(cls)) return true;
    return !!(document.body && document.body.classList.contains(cls));
  }

  function parseCount(value) {
    if (value == null || value === '') return null;
    var parsed = parseInt(String(value).replace(/,/g, ''), 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function getRccContainer() {
    return document.querySelector(RCC_CONTAINER_SELECTOR);
  }

  function isGridRendered() {
    var container = getRccContainer();
    if (!container) return false;

    return (
      container.querySelector(GRID_PRODUCT_SELECTOR) != null ||
      container.querySelector(GRID_NORESULTS_SELECTOR) != null
    );
  }

  function setTotalResultCount(value) {
    var parsed = parseCount(value);
    if (parsed != null) lastTotalResultCount = parsed;
  }

  function getProductCount(settings) {
    if (lastTotalResultCount != null) return lastTotalResultCount;

    var header = document.querySelector('.rcc-search__header');
    if (header) {
      var headerText = header.textContent || '';
      var match =
        headerText.match(/(\d[\d,]*)\s*(?:products?|items?|results?)/i) ||
        headerText.match(/\bof\s+(\d[\d,]*)\b/i);
      if (match) {
        var headerCount = parseCount(match[1]);
        if (headerCount != null) return headerCount;
      }
    }

    return parseCount(settings.productCount) || 0;
  }

  function meetsProductCountThreshold(settings) {
    var minCount =
      settings.minProductCount != null ? parseCount(settings.minProductCount) : 100;
    if (minCount == null) minCount = 100;
    return getProductCount(settings) > minCount;
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function isDismissed(settings) {
    try {
      return sessionStorage.getItem(settings.storageKey || 'hp-filter-prompt-dismissed') === '1';
    } catch (error) {
      return false;
    }
  }

  function setDismissed(settings) {
    try {
      sessionStorage.setItem(settings.storageKey || 'hp-filter-prompt-dismissed', '1');
    } catch (error) {
      // Ignore storage failures (private mode, etc.)
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatText(raw) {
    var source = raw || '';
    if (source === 'This category lists many items. We recommend you apply filters.') {
      source = 'This category lists many items.\nWe recommend you apply filters.';
    }

    var text = escapeHtml(source).replace(/\r\n|\r|\n/g, '<br>');
    var token = escapeHtml(FILTER_TOKEN);
    var parts = text.split(token);

    if (parts.length === 1) {
      return text;
    }

    return parts
      .map(function (part, index) {
        if (index === parts.length - 1) return part;
        return part + '<button type="button" class="filter-prompt__link">filter</button>';
      })
      .join('');
  }

  function openRccFilters() {
    var refine = document.querySelector(REFINE_SELECTOR);
    if (!refine) return false;
    refine.click();
    return true;
  }

  function getMountTarget() {
    if (isDesktop()) {
      return document.querySelector(DESKTOP_CONTROLS_SELECTOR);
    }

    var toolbar = document.querySelector(MOBILE_MOUNT_SELECTOR);
    if (toolbar && getComputedStyle(toolbar).display !== 'none') {
      return toolbar;
    }

    var refine = document.querySelector(REFINE_SELECTOR);
    if (refine && getComputedStyle(refine).display !== 'none') {
      return refine.parentElement || refine;
    }

    return null;
  }

  function ensureStyles() {
    if (stylesLoaded || document.getElementById(STYLE_ID)) {
      stylesLoaded = true;
      return Promise.resolve();
    }

    if (stylesLoading) return stylesLoading;

    var href = getSettings().stylesheetUrl;
    if (!href) return Promise.resolve();

    stylesLoading = new Promise(function (resolve) {
      var link = document.createElement('link');
      link.id = STYLE_ID;
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        stylesLoaded = true;
        stylesLoading = null;
        resolve();
      };
      link.onerror = function () {
        stylesLoading = null;
        resolve();
      };
      document.head.appendChild(link);
    });

    return stylesLoading;
  }

  function removePrompt(prompt) {
    if (!prompt) return;
    var host = prompt.closest('[data-filter-prompt-host]');
    prompt.remove();
    if (host && !host.querySelector('filter-prompt')) host.remove();
  }

  function mountPrompt() {
    if (document.querySelector('filter-prompt')) return true;

    var mount = getMountTarget();
    if (!mount) return false;

    var prompt = document.createElement('filter-prompt');
    prompt.classList.add('js-filter-prompt');

    if (isDesktop()) {
      // Desktop: prompt sits inside sticky filters column
      if (getComputedStyle(mount).position === 'static') {
        mount.style.position = 'relative';
      }
      mount.style.overflow = 'visible';
      mount.appendChild(prompt);
    } else {
      // Mobile: mount AFTER toolbar as sibling.
      // Do not set position:relative on toolbar — that can steal the
      // containing block from RCC and hide the product count.
      var host =
        (mount.parentElement &&
          mount.parentElement.querySelector('[data-filter-prompt-host]')) ||
        null;
      if (!host) {
        host = document.createElement('div');
        host.setAttribute('data-filter-prompt-host', '');
        mount.insertAdjacentElement('afterend', host);
      }
      host.appendChild(prompt);
    }

    return !!prompt.querySelector('.filter-prompt__bubble');
  }

  class FilterPrompt extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.render();
      this.bindEvents();
      this.position();
      this._onResize = this.position.bind(this);
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
      }
    }

    getSettings() {
      return getSettings();
    }

    position() {
      if (isDesktop()) {
        this.positionDesktop();
      } else {
        this.positionMobile();
      }
    }

    /**
     * Desktop: left caret points at the "Filters" ::before label.
     */
    positionDesktop() {
      var controls =
        this.closest(DESKTOP_CONTROLS_SELECTOR) ||
        document.querySelector(DESKTOP_CONTROLS_SELECTOR);
      if (!controls) return;

      var before = getComputedStyle(controls, '::before');
      var label = (before.content || '').replace(/^["']|["']$/g, '');
      if (!label || label === 'none') label = 'Filters';

      var font = [
        before.fontStyle,
        before.fontVariant,
        before.fontWeight,
        before.fontSize + '/' + before.lineHeight,
        before.fontFamily
      ].join(' ');

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var textWidth = 56;
      if (ctx) {
        ctx.font = font;
        textWidth = ctx.measureText(label).width;
      }

      var marginLeft = parseFloat(before.marginLeft) || 16;
      var paddingTop = parseFloat(before.paddingTop) || 16;
      var fontSize = parseFloat(before.fontSize) || 18;
      var lineHeight = parseFloat(before.lineHeight);
      if (!lineHeight || Number.isNaN(lineHeight)) lineHeight = fontSize * 1.2;

      var caretCenterY = 18 + 5;
      var filtersMidY = paddingTop + lineHeight / 2;
      var top = Math.max(0, filtersMidY - caretCenterY);
      var left = marginLeft + textWidth + 10;

      this.style.top = top + 'px';
      this.style.left = left + 'px';
      this.style.right = '';
    }

    /**
     * Mobile: sit under toolbar; caret left stays CSS (1rem).
     */
    positionMobile() {
      this.style.top = '';
      this.style.left = '';
      this.style.right = '';

      var caret = this.querySelector('.filter-prompt__caret');
      if (caret) caret.style.left = '';
    }

    render() {
      var settings = this.getSettings();
      var scheme =
        typeof settings.colorScheme === 'string' && settings.colorScheme
          ? settings.colorScheme
          : 'scheme-1';

      this.classList.add('js-filter-prompt');
      this.classList.add('color-' + scheme);
      this.setAttribute('role', 'status');

      this.innerHTML =
        '<div class="filter-prompt__bubble">' +
        '<span class="filter-prompt__caret" aria-hidden="true"></span>' +
        '<p class="filter-prompt__text filter-prompt__text--desktop">' +
        formatText(settings.textDesktop || settings.text) +
        '</p>' +
        '<p class="filter-prompt__text filter-prompt__text--mobile">' +
        formatText(settings.textMobile || settings.text) +
        '</p>' +
        '<button type="button" class="filter-prompt__close" aria-label="Close">' +
        '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M12 2L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '<path d="M12 12L2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
        '</button>' +
        '</div>';
    }

    bindEvents() {
      var self = this;

      this.addEventListener('click', function (event) {
        if (event.target.closest('.filter-prompt__close')) {
          event.preventDefault();
          event.stopPropagation();
          self.dismiss();
          return;
        }

        var link = event.target.closest('.filter-prompt__link');
        var bubble = event.target.closest('.filter-prompt__bubble');
        if (!link && !bubble) return;

        event.preventDefault();
        event.stopPropagation();
        openRccFilters();
        self.dismiss();
      });
    }

    dismiss() {
      setDismissed(this.getSettings());
      removePrompt(this);
    }
  }

  function canShow(settings) {
    if (!settings) return false;
    if (!settings.enabled && !isConvertVariantActive(settings)) return false;
    if (isDismissed(settings)) return false;
    if (!meetsProductCountThreshold(settings)) return false;
    return true;
  }

  function tryInject() {
    var settings = getSettings();
    if (!canShow(settings)) {
      removePrompt(document.querySelector('filter-prompt'));
      return false;
    }

    if (!isGridRendered()) return false;

    var existing = document.querySelector('filter-prompt');
    if (existing) {
      if (!existing.querySelector('.filter-prompt__bubble') && typeof existing.render === 'function') {
        existing._ready = false;
        existing.connectedCallback();
      }
      if (typeof existing.position === 'function') {
        existing.position();
      }
      return !!existing.querySelector('.filter-prompt__bubble');
    }

    if (!getMountTarget()) return false;
    if (injectPending) return false;

    injectPending = true;
    ensureStyles().then(function () {
      injectPending = false;
      if (!canShow(getSettings()) || !isGridRendered()) return;
      mountPrompt();
    });

    return true;
  }

  function onGridReady(event) {
    if (event && event.detail) {
      setTotalResultCount(event.detail.totalResultCount);
    }
    tryInject();
  }

  function onProductsLoadSuccess(event) {
    if (event && event.detail) {
      setTotalResultCount(event.detail.totalResultCount);
    }
    if (isGridRendered()) tryInject();
  }

  function bindRccEvents() {
    if (!gridReadyListenerBound) {
      document.addEventListener(GRID_READY_EVENT, onGridReady);
      gridReadyListenerBound = true;
    }

    if (!productsLoadListenerBound) {
      window.addEventListener(PRODUCTS_LOAD_SUCCESS_EVENT, onProductsLoadSuccess);
      productsLoadListenerBound = true;
    }
  }

  function observeRccContainer(container) {
    if (!container || observedContainers.has(container)) return false;

    if (!containerObserver) {
      containerObserver = new MutationObserver(function () {
        tryInject();
      });
    }

    containerObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    observedContainers.add(container);
    return true;
  }

  function attachRccContainerObserver() {
    return observeRccContainer(getRccContainer());
  }

  function stopContainerPoll() {
    if (containerPoll) {
      clearInterval(containerPoll);
      containerPoll = null;
    }
    if (containerPollTimeout) {
      clearTimeout(containerPollTimeout);
      containerPollTimeout = null;
    }
  }

  function observeConvertClass() {
    if (convertClassObserver) return;

    convertClassObserver = new MutationObserver(function () {
      tryInject();
    });

    convertClassObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (document.body) {
      convertClassObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function bootstrap() {
    bindRccEvents();
    observeConvertClass();

    if (attachRccContainerObserver()) {
      tryInject();
      return;
    }

    containerPoll = setInterval(function () {
      if (attachRccContainerObserver()) {
        stopContainerPoll();
        tryInject();
      }
    }, 200);

    containerPollTimeout = setTimeout(stopContainerPoll, 30000);
  }

  if (!customElements.get('filter-prompt')) {
    customElements.define('filter-prompt', FilterPrompt);
  }

  window.HealthPostFilterPrompt = {
    refresh: tryInject
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
